jQuery(document).ready(function () {

    jQuery(".tiny-slider.tiny-slider-social").each(function () {
        var sliderId = jQuery(this).data('slider');
        var currentSocialSlider = jQuery('.tiny-slider.tiny-slider-social.' + sliderId).parents('.carousel-container');

        var carouselSlider = tns({
            container: '.tiny-slider.tiny-slider-social.' + sliderId,
            items: 1,
            slideBy: 'page',
            autoplay: false,
            mouseDrag: false,
            controls: false,
            nav: false,
            loop: false,
            responsive: {
                600: {
                    items: 2
                },
                1024: {
                    items: 4
                }
            }
        });

        // Calculate slider indicators width based on how many there are
        var totalIndicators = currentSocialSlider.find('.carousel-navigation .bar .indicator').length;
        var indicatorWidth = 100 / totalIndicators;
        currentSocialSlider.find('.carousel-navigation .bottom .bar .indicator').css({'width': ((indicatorWidth <= 6) ? '8px' : indicatorWidth + '%')});

        // Go to specific slide when clicking on navigation indicator
        currentSocialSlider.find('.carousel-navigation').on('click', '.indicator', function () {
            var indicatorNo = jQuery(this).data('slide-no');
            carouselSlider.goTo(indicatorNo);
        });
        // Controls
        currentSocialSlider.find('.carousel-navigation').on('click', '.prev', function () {
            carouselSlider.goTo('prev');
        });
        currentSocialSlider.find('.carousel-navigation').on('click', '.next', function () {
            carouselSlider.goTo('next');
        });
    });
});